import { buildBuyersAttorneyContactCard } from '../../shared';

export const buyersAttorneyContactCard = buildBuyersAttorneyContactCard(
  'counterpartyAttorney',
);
